import {getMethod} from '@/api'

async function get(request) {
    return await getMethod('/api/downloadOrders', request, null, {responseType: 'arraybuffer'})
}

export {get}
